import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import Header from "./Header";
import Footer from "./Footer";

import { Config } from "../../config/Config";
import { GetProfileAction } from '../../redux/Action/ProfileAction';
import { saveToStorage } from '../../utils/Helper';
import { StorageConstants } from '../../constants/Constants';
import Spinner from "../Spinner";
import Sidebar from "./Sidebar";


const Layout = () => {
    const dispatch = useDispatch<any>();
    const { pathname } = useLocation();
    const profileData = useSelector((state: any) => state.GetProfileState);
    const [profileState, setProfileState] = useState(profileData?.data?.data?.is_profile_setup ? profileData?.data?.data?.is_profile_setup : null)
    const [isLoadingData, setIsLoadingData] = useState(true);


    const basePath = pathname.split('/')[1];
    const isBookingsDetailsPath = pathname.startsWith('/my-bookings-details');

    const path_name = ["dashboard", "contact-support", "service-management", "my-profile", `service-management/view/${basePath}`, "staff-member",
        `my-bookings`,
        `billing`,
        "my-bookings-details",
        'sales-growth-management',
        "subscription-plans",
        "subscription-purchase",
        // `/my-bookings-details/${basePath}/${basePath}/${basePath}`,
        "salon-availability",
        "staff-availability",
        "change-password",
        `service-update`,
        `staff-member/view/${basePath}`,
        `staff-member/update/${basePath}`,
        `billing-management-view`,
        `offline-booking`

    ]

    const payload = {
        name: profileData?.data?.data?.salon_name,
        email: profileData?.data?.data?.email,
        image: profileData?.data?.data?.buisness_images?.[0]?.file_path
    }

    useEffect(() => {
        if (profileData?.status) {
            saveToStorage({ key: StorageConstants?.USER_DETAIL, value: profileData?.data?.data })
            setProfileState(profileData?.data?.data?.is_profile_setup)
        }
    }, [profileData])


    useEffect(() => {
        if (Config?.IS_USER_LOGIN_TOKEN) {
            dispatch(GetProfileAction({}))
        }
        setIsLoadingData(false);
    }, []);


    if (isLoadingData) {
        return <Spinner />;
    }


    return (
        <>
            {
                profileData?.loading ? <Spinner /> :
                    (Config?.USER_DETAILS?.role_id == 2 || profileData?.data?.data?.is_profile_setup != 0) ? (
                        <>
                            <Header payload={payload} />
                            {
                                path_name.includes(basePath) ? <main> <div className='container-fluid my-5'>
                                    <div className='row align-items-stretch'>
                                        <div className='col-lg-3 leftsidebar'>
                                            <Sidebar />
                                        </div>

                                        <Outlet />
                                    </div>
                                </div></main> : <Outlet />
                            }
                            <Footer />
                        </>
                    ) : <Outlet />
            }
            {/* {
                profileData?.data?.data?.is_profile_setup != 0 || Config?.USER_DETAILS?.is_profile_setup != 0 ? (
                    <>
                        <Header name={profileData?.data?.data?.salon_name} email={profileData?.data?.data?.email} />
                        <Outlet />
                        <Footer />
                    </>
                ) : <Outlet />
            } */}
        </>
    )
}

export default Layout;